// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users-list-labels-list__item {
  margin-right: var(--g-spacing-2);
}
.users-list-labels-list__button {
  flex-shrink: 0;
  margin-right: var(--g-spacing-2);
}
.users-list-labels-list__popup {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: var(--g-spacing-2) var(--g-spacing-1) var(--g-spacing-2) var(--g-spacing-2);
}
.users-list-labels-list__popup .users-list-labels-list__item {
  margin: var(--g-spacing-2) 0;
}
.users-list-labels-list__popup-content {
  max-height: 200px;
  overflow-y: auto;
  display: flex;
  gap: var(--g-spacing-2);
  flex-direction: column;
  padding-right: var(--g-spacing-1);
}`, "",{"version":3,"sources":["webpack://./src/ui/units/service-settings/components/UsersList/LabelsList/LabelsList.scss"],"names":[],"mappings":"AAGI;EACI,gCAAA;AAFR;AAKI;EACI,cAAA;EACA,gCAAA;AAHR;AAMI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,oFAAA;AAJR;AAMQ;EACI,4BAAA;AAJZ;AAQI;EACI,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,iCAAA;AANR","sourcesContent":[".users-list-labels-list__item {\n  margin-right: var(--g-spacing-2);\n}\n.users-list-labels-list__button {\n  flex-shrink: 0;\n  margin-right: var(--g-spacing-2);\n}\n.users-list-labels-list__popup {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: var(--g-spacing-2) var(--g-spacing-1) var(--g-spacing-2) var(--g-spacing-2);\n}\n.users-list-labels-list__popup .users-list-labels-list__item {\n  margin: var(--g-spacing-2) 0;\n}\n.users-list-labels-list__popup-content {\n  max-height: 200px;\n  overflow-y: auto;\n  display: flex;\n  gap: var(--g-spacing-2);\n  flex-direction: column;\n  padding-right: var(--g-spacing-1);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
